import { render, staticRenderFns } from "./OrganizeManage.vue?vue&type=template&id=4c648ae9&scoped=true"
import script from "./OrganizeManage.vue?vue&type=script&lang=js"
export * from "./OrganizeManage.vue?vue&type=script&lang=js"
import style0 from "./OrganizeManage.vue?vue&type=style&index=0&id=4c648ae9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c648ae9",
  null
  
)

export default component.exports